export const TIPO_COMIDA = {
  SOPA: "SOPA",
  PLATO1: "PLATO1",
  PLATO2: "PLATO2",
  DIETA: "DIETA",
  POSTRE: "POSTRE",
  ALERGENOS: "ALERGENOS",
};

export const TIPO_COMIDA_LABEL = {
  PLATO1: "Plato 1",
  PLATO2: "Plato 2",
  SOPA: "Sopa",
  POSTRE: "Postre",
  DIETA: "Dieta",
  ALERGENOS: "Alergenos",
};
